import { ChangeDetectionStrategy, Component, OnInit, input, signal } from "@angular/core";
import { IonicModule, isPlatform, ModalController } from "@ionic/angular";
import { ModeService } from "src/app/utils/mode.service";
import { InvoiceItemDto } from "../../interfaces/invoice_item_dto";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ProductListComponent } from "src/app/products/containers/product-list/product-list.component";

@Component({
    selector: "app-invoice-item-form",
    templateUrl: "./invoice-item-form.component.html",
    styleUrls: ["./invoice-item-form.component.scss"],
    imports: [IonicModule, FormsModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceItemFormComponent implements OnInit {
  invoiceItemForm: FormGroup;
  today = new Date();
  formattedDate = this.today.toISOString().substr(0, 10);
  subscriptionPrize: 0;

  readonly invoiceItem = input<InvoiceItemDto>(undefined);

  constructor(
    public modeService: ModeService,
    private modalController: ModalController
  ) {
    this.invoiceItemForm = new FormGroup({
      name: new FormControl("", Validators.required),
      prize: new FormControl(0, Validators.required),
      amount_prize: new FormControl(0, Validators.required),
      amount: new FormControl(1, Validators.required),
      description: new FormControl(""),
      unit: new FormControl("Stk", Validators.required),
      date: new FormControl(this.formattedDate, Validators.required),
      appointment_id: new FormControl(""),
      id: new FormControl(null),
      subscription_payment: new FormControl(true),
      subscription_id: new FormControl(null),
      initial_prize: new FormControl(null),
    });
  }

  ngOnInit() {
    let invoiceItem = { ...this.invoiceItem() };
    if (invoiceItem) {
      if (invoiceItem.unit === "Lektion") {
        invoiceItem.unit = "Lektionen";
      }
      if (invoiceItem?.initial_prize !== invoiceItem.prize) {
        invoiceItem.prize = invoiceItem.initial_prize;
      }
      this.invoiceItemForm.patchValue(invoiceItem);
      this.updateAmountPrize();

      // Add subscription to watch subscription_payment changes
      this.invoiceItemForm.get('subscription_payment').valueChanges.subscribe(isSubscription => {
        if (!isSubscription) {
          this.invoiceItemForm.patchValue({
            description: '',
            subscription_id: null,
          });
        }
      });
    }
  }

  async cancel() {
    if (await this.modalController.getTop()) {
      this.modalController.dismiss();
    }
  }

  updatePrize() {
    // update the prize to be the amount * amount_prize
    this.invoiceItemForm.patchValue({
      prize:
        this.invoiceItemForm.value.amount *
        this.invoiceItemForm.value.amount_prize,
      initial_prize:
        this.invoiceItemForm.value.amount *
        this.invoiceItemForm.value.amount_prize,
    });
  }

  updateAmountPrize() {
    // update the amount_prize to be the prize / amount
    this.invoiceItemForm.patchValue({
      amount_prize:
        this.invoiceItemForm.value.prize / this.invoiceItemForm.value.amount,
      initial_prize: this.invoiceItemForm.value.prize,
    });
  }

  save() {
    // save the invoiceItem
    if (
      this.invoiceItemForm.value.unit === "Lektionen" &&
      this.invoiceItemForm.value.amount === 1
    ) {
      this.invoiceItemForm.patchValue({
        unit: "Lektion",
      });
    }

    var invoiceItem = this.invoiceItemForm.value as InvoiceItemDto;

    if (this.modalController.getTop()) {
      this.modalController.dismiss(invoiceItem);
    }
  }

  async selectProduct() {
    const modal = await this.modalController.create(
      isPlatform("desktop") ||
      isPlatform("phablet") ||
      isPlatform("ipad") ||
      (isPlatform("tablet") && !isPlatform("mobile") && !isPlatform("iphone"))
      ? {
          component: ProductListComponent,
          componentProps: {
            isSelection: signal(true),
          },
          canDismiss: true,
          showBackdrop: true,
        }
      : {
          component: ProductListComponent,
          componentProps: {
            isSelection: signal(true),
          },
          canDismiss: true,
          showBackdrop: true,
          backdropDismiss: true,
          breakpoints: [0, 0.6, 1],
          initialBreakpoint: 0.6,
        }
    );

    modal.onDidDismiss().then((result) => {
      if (result.data) {
        const product = result.data;
        this.invoiceItemForm.patchValue({
          name: product.name,
          description: product.description,
          amount_prize: product.prize,
          prize: product.prize,
          initial_prize: product.prize,
          unit: product.unit,
        });
      }
    });

    return modal.present();
  }
}
